<template>
  <v-container grid-list-xl>
    <v-layout wrap justify-space-between>
      <v-flex xs12 md12>
        <v-alert :value="alert" type="success">Başarıyla kaldedildi.</v-alert>
      </v-flex>
      <v-flex xs12 md6>
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="setting.hasStartDate"
              label="Has Altın Ortalama Başlangıç Tarihi"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="setting.hasStartDate" @input="menu2 = false"></v-date-picker>
        </v-menu>
        <v-menu
          ref="menu3"
          v-model="menu3"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="time"
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="setting.hasStartTime"
              label="Has Altın Ortalama Başlangıç Saati"
              prepend-icon="access_time"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="menu3"
            v-model="setting.hasStartTime"
            full-width
            format="24hr"
            @click:minute="$refs.menu3.save(time)"
          ></v-time-picker>
        </v-menu>

  <v-menu
          v-model="menu4"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="setting.hasEndDate"
              label="Has Altın Ortalama Bitiş Tarihi"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="setting.hasEndDate" @input="menu4 = false"></v-date-picker>
        </v-menu>
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="time"
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="setting.hasEndTime"
              label="Has Altın Ortalama Bitiş Saati"
              prepend-icon="access_time"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="menu1"
            v-model="setting.hasEndTime"
            full-width
            format="24hr"
            @click:minute="$refs.menu1.save(time)"
          ></v-time-picker>
        </v-menu>

       
        <v-text-field v-model="setting.company.name" label="Şirket Adı" :counter="max" required />
        <v-text-field v-model="setting.company.country" label="Ülke" :counter="max" required />
        <v-text-field v-model="setting.company.cityName" label="Şehir" :counter="max" required />
        <v-text-field
          v-model="setting.company.citySubdivisionName"
          label="İlçe"
          :counter="max"
          required
        />
        <v-text-field v-model="setting.company.streetName" label="Cadde" :counter="max" required />
        <v-text-field
          v-model="setting.company.buildingNumber"
          label="Bina No"
          :counter="max"
          required
        />
        <v-text-field
          v-model="setting.company.postalZone"
          label="Posta Kodu"
          :counter="max"
          required
        />
        <v-text-field v-model="setting.company.eMail" label="E-mail" :counter="max" required />
        <v-text-field v-model="setting.company.mersisNo" label="Mersis No" :counter="max" required />
        <v-text-field v-model="setting.company.phone" label="Telefon" :counter="max" required />

        <v-text-field v-model="setting.company.taxNumber" label="Vergi No" :counter="max" required />
        <v-text-field
          v-model="setting.company.taxOffice"
          label="Vergi Dairesi"
          :counter="max"
          required
        />
        <v-text-field
          v-model="setting.company.tradeRegistryNumber"
          label="Ticari Sicil No"
          :counter="max"
          required
        />
        <v-text-field v-model="setting.company.webSite" label="WebSite" :counter="max" required />
        <v-text-field v-model="setting.uyumServer" label="Uyum Web Servis" :counter="max" required />
        <v-text-field
          v-model="setting.uyumUserName"
          label="Uyum Kullanıcı Adı"
          :counter="max"
          required
        />
        <v-text-field v-model="setting.uyumPassword" label="Uyum şifre" :counter="max" required />

        <v-text-field
          v-model="setting.incrementMax"
          label="Numaratör Max Counter"
          :counter="max"
          required
        />

        <v-text-field
          v-model="setting.stockAlertCount"
          label="Stok Alert sayısı"
          :counter="max"
          required
        ></v-text-field>
        <v-text-field v-model="setting.merchantId" label="Merchant Id" :counter="max" required></v-text-field>
        <v-text-field v-model="setting.mpUserName" label="Kullanıcı Adı" :counter="max" required></v-text-field>
        <v-text-field
          v-model="setting.mpPassword"
          type="password"
          label="Şifre"
          :counter="max"
          required
        ></v-text-field>
        <v-text-field v-model="setting.smtp.server" label="Mail Server" :counter="max" required></v-text-field>
        <v-text-field
          v-model="setting.smtp.to"
          label="Mail Kime Mail Gönderilecek"
          :counter="max"
          required
        ></v-text-field>
        <v-text-field v-model="setting.smtp.from" label="Mail Kimden" :counter="max" required></v-text-field>
        <v-text-field
          v-model="setting.smtp.userName"
          label="Mail Kullanıcı Adı"
          :counter="max"
          required
        ></v-text-field>
        <v-text-field
          v-model="setting.smtp.password"
          type="password"
          label="Mail Şifre"
          :counter="max"
          required
        ></v-text-field>
        <v-text-field
          v-model="setting.cargo.name"
          label="Kargo Şirketi Adı"
          :counter="max"
          required
        ></v-text-field>
        <v-text-field
          v-model="setting.cargo.taxNumber"
          label="Kargo Vergi No"
          :counter="max"
          required
        ></v-text-field>
        <v-text-field
            v-model="setting.stopajFormul"
            label="Stopaj Formül"
            :counter="max"
            required
        ></v-text-field>
        <v-text-field
            v-model="setting.kargoFormul"
            label="Kargo Fiyatı (KDV'li)"
            :counter="max"
            required
        ></v-text-field>
         <v-text-field
            v-model="setting.laborConstant"
            label="İşçilik Sabiti (KDV'li)"
            :counter="max"
            required
        ></v-text-field>
        <v-text-field
            v-model="setting.increaseConstantPerGram"
            label="İşçilik Gram Başı Artış Sabiti (KDV'li)"
            :counter="max"
            required
        ></v-text-field>
        <v-text-field
            v-model="setting.komisyonFormul"
            label="Market Place Komisyon Oranı (KDV'siz)"
            :counter="max"
            required
        ></v-text-field>
        <v-text-field
            v-model="setting.hizmetBedeliFormul"
            label="Hizmet Bedeli Formül"
            :counter="max"
            required
        ></v-text-field>
        <v-text-field
            v-if="isMpId5"
            v-model="setting.idiaTransferPriceRate"
            label="Idia Transfer Fiyat Oranı"
            type="number"
            step="0.0001"
            :counter="max"
        ></v-text-field>
        <v-switch v-model="setting.smtp.ssl" :label="`Mail Ssl: ${setState(setting.smtp.ssl)}`"></v-switch>
        <v-switch v-model="setting.state" :label="`Setting Durumu: ${setState(setting.state)}`"></v-switch>
      </v-flex>
      <v-btn color="success" @click="savesetting">Kaydet</v-btn>
    </v-layout>
  </v-container>
</template>
<script>
import { authenticationService } from "@/_services";

export default {
  data: () => ({
    alert: false,
    allowSpaces: false,
    max: 0,
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    menu1: false,
    time: null,
    menu2: false,
    menu3: false,
    menu4: false,
    setting: {
      company: {},
      state: true,
      smtp: {},
      cargo: {}
    }
  }),

  watch: {},

  methods: {
    setState(state) {
      if (state) return "Aktif";
      return "Pasif";
    },
    async savesetting() {
      let setting = Object.assign({}, this.setting);
      if (this.setting.id) this.$store.dispatch("settings/putSetting", setting);
      else this.$store.dispatch("settings/postSetting", setting);
      this.alert = true;
    },
    validateField() {
      this.$refs.form.validate();
    }
  },
  computed: {
    isMpId5() {
      const selectedMp = localStorage.getItem('selectedMpId');
      const currentUser = authenticationService.currentUserValue;
      const mpId = selectedMp || (currentUser && currentUser.mpId);
      return mpId == 5 || mpId === '5';
    }
  },
  async mounted() {
    await this.$store.dispatch("settings/getSettings");
    this.setting = this.$store.state.settings.setting;
    
    this.setting.company = this.setting.company || {};
    this.setting.smtp = this.setting.smtp || {};
    this.setting.cargo = this.setting.cargo || {};
    
    this.setting.state = this.setting.state !== undefined && this.setting.state !== null ? this.setting.state : false;
    
    if (this.setting.hasStartDate) {
      this.setting.hasStartDate = this.setting.hasStartDate.substr(0, 10);
    }
    if (this.setting.hasEndDate) {
      this.setting.hasEndDate = this.setting.hasEndDate.substr(0, 10);
    }
    if (this.setting.hasStartTime) {
      this.setting.hasStartTime = this.setting.hasStartTime.substr(0, 5);
    }
    if (this.setting.hasEndTime) {
      this.setting.hasEndTime = this.setting.hasEndTime.substr(0, 5);
    }
  }
};
</script>